import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { Store } from '@ngrx/store';

import { FeatureFlagService } from '@amfam/shared/utility/feature-flag/data-access/lib/services/feature-flag.service';
import { fromRouterActions } from '@amfam/shared/utility/navigation/lib/+state/router-actions';

export const maintenanceGuard: CanActivateFn = (): boolean => {
  const featureFlag = inject(FeatureFlagService);
  const store = inject(Store);

  if (featureFlag.isEnabled('global_outage')) {
    store.dispatch(
      fromRouterActions.Go({
        path: ['/outage']
      })
    );
    return false;
  }
  if (featureFlag.isEnabled('maintenance_redirect')) {
    store.dispatch(
      fromRouterActions.Go({
        path: ['/maintenance']
      })
    );
    return false;
  }
  return true;
};
